<head>
    <title>{{ title }}</title>
</head>
<router-outlet></router-outlet>
